// @flow

import React from 'react';
import { FormattedDate } from 'react-intl';

type Props = {
  startDate: string,
  endDate: string,
  formatOptions?: ?{
    year: string,
    month: string,
    day: string,
  },
};

/**
 * EventDate
 *
 * @param {Props} props
 */
export const EventDate = ({ startDate, endDate, formatOptions = null }: Props) => {
  const formatProps = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    ...formatOptions,
  };

  return (
    <React.Fragment>
      <FormattedDate value={startDate} {...formatProps}>
        {(startDate: string) => startDate}
      </FormattedDate>
      <span>&nbsp;&mdash;&nbsp;</span>
      <FormattedDate value={endDate} {...formatProps}>
        {(endDate: string) => endDate}
      </FormattedDate>
    </React.Fragment>
  );
};
